export default __webpack_public_path__ + "static/media/checked.327bf7c0.svg";